import { withStyle } from '@instructure/emotion';
import { applyComponentStyleOverride } from './applyComponentStyleOverride';
export function withStyleOverrides(generateStyle, generateComponentTheme) {
  return function (Component) {
    var generateComponentStyle = applyComponentStyleOverride(Component.componentId, generateStyle);
    return withStyle(generateComponentStyle, generateComponentTheme)(Component);
  };
}